document.addEventListener('DOMContentLoaded', function () {
   function highlightActiveMenuItem() {
      const currentPath = window.location.pathname;

      const miniMenus = document.querySelectorAll('.qlf-mini-menu');

      miniMenus.forEach((menu) => {
         const menuItems = menu.querySelectorAll('nav ul li');

         menuItems.forEach((item) => {
            item.classList.remove('active');
         });

         menuItems.forEach((item) => {
            const link = item.querySelector('a');
            if (link) {
               const linkUrl = new URL(link.href);
               const linkPath = linkUrl.pathname;

               if (currentPath === linkPath) {
                  item.classList.add('active');
               }
            }
         });
      });
   }

   highlightActiveMenuItem();
});
